import { GetDealCheckAPI } from '@/api/dealcheck'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取批处理查询数据
    async getdealcheck({ commit }, item) {
      const res = await GetDealCheckAPI(item)
      return res
    }
  }
}
